import apiClient from '../api-client';

export const getRecommendedWineries = () => apiClient.get('winery/recommended').then(res => res.data);
export const getWinery = (slug) => apiClient.get('winery/' + slug).then(res => res.data);
export const searchWineries = (query) => apiClient.get('winery/search', { params: { query }}).then(res => res.data);
